const ADMIN_SUB_VALUES = [
  { routerLink: '/admin/search', displayText: $localize`Admin Search` },
  { routerLink: '/admin/user-admin', displayText: $localize`User Admin` },
  {
    routerLink: '/admin/location-admin',
    displayText: $localize`Location Admin`,
  },
  {
    routerLink: '/admin/location-group',
    displayText: $localize`Location Group`,
  },
  { routerLink: '/admin/route-admin', displayText: $localize`Route Admin` },
  { routerLink: '/admin/device-admin', displayText: $localize`Device Admin` },
  {
    routerLink: '/admin/access-point',
    displayText: $localize`Access Point/ADL`,
  },
  {
    routerLink: '/admin/building-scan-admin',
    displayText: $localize`Building Scan Admin`,
  },
];

const OPERATION_SUB_VALUES = [
  {
    routerLink: '/operations/route-summary',
    displayText: $localize`Route Summary`,
  },
  {
    routerLink: '/operations/pickup-assignment',
    displayText: $localize`Pickup Assignments`,
  },
];

const EXCEPTIONS_SUB_VALUES = [
  {
    routerLink: '/exceptions/building-scan',
    displayText: $localize`Building Scan`,
  },
  {
    routerLink: '/exceptions/intercepts',
    displayText: $localize`Intercepts`,
  },
  { routerLink: '/exceptions/exceptions', displayText: $localize`Exceptions` },
  {
    routerLink: '/exceptions/print-shipping-label',
    displayText: $localize`Print Shipping Label`,
  },
];

export const DISPLAY_CONSTANTS = {
  APP_NAME: $localize`Global Pickup and Delivery (GPD)`,
  APP_NAME_SMALL: $localize`GPD`,
  PROFILE_USER_NAME: {
    PROFILE: $localize`My Profile`,
    NOTIFICATIONS: $localize`Notifications`,
  },
  NAVIGATION_BAR_TEXT: {
    HOME: {
      idOn: 'homeON',
      idOff: 'home',
      imageOn: 'assets/HomeON.svg',
      imageOff: 'assets/Home.svg',
      displayText: $localize`Home`,
    },
    ADMIN: {
      idOn: 'adminON',
      idOff: 'admin',
      displayText: $localize`Admin`,
      subValues: ADMIN_SUB_VALUES,
      icon: 'assets/sidebar-icons/people.svg',
    },
    OPERATIONS: {
      idOn: 'operationsON',
      idOff: 'operations',
      displayText: $localize`Operations`,
      subValues: OPERATION_SUB_VALUES,
      icon: 'assets/sidebar-icons/truck.svg',
    },
    EXCEPTIONS: {
      idOn: 'exceptionsON',
      idOff: 'exceptions',
      displayText: $localize`Exceptions`,
      subValues: EXCEPTIONS_SUB_VALUES,
      icon: 'assets/sidebar-icons/building.svg',
    },
    MESSAGES: {
      idOn: 'messagesON',
      idOff: 'messages',
      displayText: $localize`Messages`,
      icon: 'assets/sidebar-icons/speech.svg',
    },
    REPORTS: {
      idOn: 'reportsON',
      idOff: 'reports',
      displayText: $localize`Reports`,
      icon: 'assets/sidebar-icons/file.svg',
    },
    LOGOUT: {
      idOn: 'logoutON',
      idOff: 'logout',
      imageOn: 'assets/LogoutON.svg',
      imageOff: 'assets/Logout.svg',
      displayText: $localize`Logout`,
    },
  },
  SEARCH_BAR_PLACEHOLDER: $localize`Search Tracking Number`,
  LOADING_TEXT: $localize`Loading...`,
  GROUP_TEXT: $localize`Group`,
  LOCATION_TEXT: $localize`Location`,
  SEARCH: $localize`Search Here`,
};
